/*
 * Which pregnancy the Assign dialog opens on.
 *
 * "Latest not complete" is read exactly as the pregnancy card reads it (KIN-1941): a pregnancy is
 * open while its own completion flag says so, never inferred from the estimated due date, and where
 * several are open the most recently created wins. That last part is not an arbitrary tie-break —
 * it is the rule the backend's `findCurrentPregnancyId` applies when it routes an inbound hospital
 * message on its own, so a default picked any other way would quietly disagree with where every
 * automatically matched message of the same batch landed.
 *
 * Sidebar order (`sortPregnanciesForSidebar`) deliberately isn't used: it sorts the open group by
 * last menstrual period for reading, and a pregnancy entered retrospectively would then win a
 * default the backend would never have chosen.
 */
import { selectCurrentPregnancy } from "features/pregnancy/utils/currentPregnancy";

// Select's placeholder value — "No pregnancy yet", which a hospital message genuinely can need.
export const NO_PREGNANCY = "";

export const getDefaultPregnancyId = (pregnancies) => {
  const current = selectCurrentPregnancy(pregnancies);

  return current ? String(current.id) : NO_PREGNANCY;
};
